export default __webpack_public_path__ + "static/media/cp_geo_gm.3c66b459.svg";